
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 6s-2.344 1.594-3.765 2.472A5 5 0 019 9H1.807C.849 9.221 0 10.558 0 12.085 0 13.557.812 14.771 1.807 15H9c.775 0 1.541.149 2.235.497C12.812 16.469 15 18 15 18V6zm-8 7a1 1 0 110-2 1 1 0 010 2zm11-7v12h-2V6h2zm6 7h-4v-2h4v2zm0-6.5l-3.094 2.188-1.084-1.5L22.916 5 24 6.5zM22.916 19l-3.094-2.188 1.084-1.5L24 17.5 22.916 19z"}})])
          )
        }
      }
    